import { render, staticRenderFns } from "./courseBalanceStudioCosts.vue?vue&type=template&id=01d2c98e&scoped=true&"
import script from "./courseBalanceStudioCosts.vue?vue&type=script&lang=js&"
export * from "./courseBalanceStudioCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2c98e",
  null
  
)

export default component.exports